import { ca } from '@cian/analytics';

import { tabTypes, TTabId } from '../components/map_block/constants';
import { TIndexableObject } from '../interfaces/village';

const ANALYTICS_MAP_TABS_ACTIONS: TIndexableObject = {
  [tabTypes.generalPlan]: 'map_click_tab_genplan',
  [tabTypes.panorama]: 'map_click_tab_panorama',
  [tabTypes.map]: 'map_click_tab_on_map',
};

export const trackMapTabClick = (tab: TTabId) => {
  ca('event', {
    category: 'Card_KP',
    label: '',
    name: 'oldevent',
    action: ANALYTICS_MAP_TABS_ACTIONS[tab],
  });
};
